import * as vp from 'vopay';
import { useEffect } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';
const { api } = vopayApi;

type ResetPasswordReturn = {
  resetPassword: (request: vp.ClientResetPasswordEmailRequest) => Promise<vp.ClientResetPasswordEmailResponse>;
};

function useResetPassword(bearer?: string): ResetPasswordReturn {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const resetPassword = async (request: vp.ClientResetPasswordEmailRequest) => {
    const res = await api.postClientResetPasswordEmail(request, source, bearer);
    if (!res.Success) throw new Error(res.ErrorMessage);
    return res;
  };

  return { resetPassword };
}
export default useResetPassword;
